// eslint-disable-next-line import/prefer-default-export
export const readingRoomAccessColumns = {
  NAME: 'name',
  ISPUBLIC: 'isPublic',
  SERVICEPOINTS: 'servicePoints',
};

export const readingRoomsLimit = 25;
